import React, { useState, useEffect, useCallback, useRef } from 'react';
import { GoCalendar } from "react-icons/go";
import { LuFileText,LuSend } from "react-icons/lu";
import { FiEdit,FiClock } from "react-icons/fi";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { useDispatch, useSelector } from "react-redux";
import { getScheduledQueueList,putScheduledDraft, getPublishNow } from "../../../../../../store/actions/cms/scheduler";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { RxCross2 } from "react-icons/rx";
import SetSchedulePopup from '../setSchedulePopup';
import Loading from "../../../../utils/loader";
import { NoDataFound } from '../../../../utils/noDataFound';
import ShowToastMsg from '../../../../utils/showToastMsg';
import {clearData} from "../../../../../../store/slices/scheduler";
import { format } from 'date-fns';
import { findPermission } from '../../../../../utils';

const ScheduledContentDashboard = (props) => {
    const dispatch = useDispatch();
    const [hasNextPage, setHasNextPage] = useState(false);
    const [groupedData, setGroupedData] = useState({});
    const [data, setData] = useState([]);
    const [showSchedulePopup, setSchedulePopup] = useState(null);
    const [customDate, setCustomDate] = useState(null);
    const [customTime, setCustomTime] = useState("");
    const observerRef = useRef(null); // Ref for the intersection observer
    let FilterApplied = JSON.parse(localStorage.getItem('filterApplied'));
    const activeTab = localStorage.getItem('activeContentTab');
    
    const { queueDrafsLoading, queueDraftsData,queueDraftsError, putScheduleDraftsData,punlishNowError,publishNowData } = useSelector((state) => {
        return (state?.contentSchedularReducer);
    });
    const currentUser = useSelector((state) => state?.userData?.user?.data);
    // Get the current time
    const currentTime = new Date().toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    });
    
    // Get the current date
    const currentDate = new Date().toLocaleDateString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
    });
    const date = new Date(customDate) || new Date();
    const formatted = format(date, "EEEE, d MMMM");
    const putMessage = `<div><div><strong>Successfully Scheduled</strong></div><div>Your post is set to go live on <strong>${formatted}, at ${customTime?.value}</strong>.</div></div>`
    const successMsg= publishNowData? `<div><div><strong>Successfully Published</strong></div><div>Your post is published on <strong>${currentDate}, at ${currentTime}</strong>.</div></div>`: putMessage;
    
    // to show cards by grouping dates
    const groupDataByDate = useCallback((items) => {
        const grouped = {};
        items.forEach(item => {
            // Use the full date string (including the year) for grouping
            const dateStr = new Date(item.scheduled_publish_at).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
            });
    
            if (!grouped[dateStr]) {
                grouped[dateStr] = [];
            }
            grouped[dateStr].push(item);
        });
    
        Object.keys(grouped).forEach(date => {
            grouped[date].sort((a, b) => {
                const timeA = new Date(a.scheduled_publish_at);
                const timeB = new Date(b.scheduled_publish_at);
                return timeA - timeB;
            });
        });
    
        return grouped;
    }, []);

    // called get API after succes of PUTand publishNow API on cancel schedule
    useEffect(() => {
        if (putScheduleDraftsData || publishNowData) {
            // setSchedulePopup(null);
            window.scrollTo({
                top: 0,
                behavior: "smooth"   // smooth scrolling
            });
            props.setQueueCurrentPage(1);
            setTimeout(() => {
                dispatch(clearData());
            }, 3000);
            dispatch(getScheduledQueueList({page:1,page_size:12,...FilterApplied}))
        }
        if(punlishNowError){
            setTimeout(() => {
                dispatch(clearData());
            }, 3000);
        }
        return ()=>{
            localStorage?.removeItem('filterApplied')
          }
    }, [putScheduleDraftsData, publishNowData,punlishNowError])

    // updating data for pagination
    useEffect(() => {
        const loadInitialData = async () => {
            if (queueDraftsData) {
                if (props.queueCurrentPage === 1) {
                    // Reset data for page 1
                    setData(() => {
                        const uniqueData = queueDraftsData.results.filter(
                            (item, index, self) =>
                                index === self.findIndex((t) => t.id === item.id)
                        );
                        return uniqueData;
                    });
                } else {
                    // Append data for subsequent pages
                    setData((prevData) => {
                        const mergedData = [...prevData, ...queueDraftsData.results];
                        const uniqueData = mergedData.filter(
                            (item, index, self) =>
                                index === self.findIndex((t) => t.id === item.id)
                        );
                        return uniqueData;
                    });
                }
                setHasNextPage(queueDraftsData.next !== null);
                props.setQueueCurrentPage(queueDraftsData.current);
            }
        };
        loadInitialData();
    }, [queueDraftsData, props.queueCurrentPage]);

    // grouping of data by date and updating state to show card counter
    useEffect(() => {
        setGroupedData(groupDataByDate(data));
        props.setQueueLength(data?.length);
    }, [data, groupDataByDate]);

    // to call APi with next page
    const fetchNextPage = async () => {
        if (hasNextPage && !queueDrafsLoading) {
            dispatch(getScheduledQueueList({ page: props.queueCurrentPage + 1, page_size: 12, ...FilterApplied }));
        }
    };

    // to observe interaction with observerRef (observation to scroll)
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    // console.log("intersecting")
                    fetchNextPage();
                }
            },
            { threshold: 1.0 }
        );

        if (observerRef.current) {
            observer.observe(observerRef.current);
        }

        return () => {
            if (observerRef.current) {
                observer.unobserve(observerRef.current);
            }
        };
    }, [observerRef, hasNextPage, props.queueCurrentPage, queueDrafsLoading]);


    const MoreTooltip = ({ onEdit, onPublish, onCancel }) => {
        const popover = (
            <Popover id="popover-basic custom_tooltip" className="custom-menu shadow tool_tip_block">
                <div
                    className="tool_tip_item item_1"
                    style={{ cursor: "pointer" }}
                    onClick={onEdit}
                >
                    <FiEdit /> Edit
                </div>
                <div
                    className="tool_tip_item item_2"
                    style={{ cursor: "pointer" }}
                    onClick={onPublish}
                >
                    <LuSend /> Publish Now
                </div>
                <div
                    className="tool_tip_item item_3"
                    style={{ cursor: "pointer" }}
                    onClick={onCancel}
                >
                    <RxCross2 /> Cancel Schedule
                </div>
            </Popover>
        );

        return (
            <OverlayTrigger trigger="click" placement="bottom-end" overlay={popover} rootClose>
                <div style={{ cursor: "pointer" }} className='dot_vertical'>
                    <HiOutlineDotsVertical />
                </div>
            </OverlayTrigger>
        );
    };

    // open popup for schedule draft
    const handleReschedule = (draft) => {
        setSchedulePopup(draft);
        setCustomDate(null);
        setCustomTime("");
    };

    // handling schedule for cancelling
    const handleCancleSchedule = (draft) =>{
        let data = {
            "id": draft?.id,
            "task_status": 'cancelled',
            "scheduled_by": currentUser?.id || 1,
        }
        dispatch(putScheduledDraft(data));
    }

    const handlePublishNow = (draft) => {
       dispatch(getPublishNow({id:draft?.id}));
    }

    // card UI
    const ContentCard = ({ item,parentIndex,isToday}) => (
        <div className='queue_block'>
            <div className="">
                <div className="card-body">
                    <div className="d-flex justify-content-between mb-3">
                        <div className="d-flex align-items-center">
                            <div className={`badges green_badge`}>
                                <LuFileText />
                            </div>
                            <div>
                                <div className='text_type'>TYPE</div>
                                <div className='text_head'>{item.content_type?.charAt(0).toUpperCase() + item.content_type.slice(1)}</div>
                            </div>
                        </div>
                        {item.scheduled_publish_at &&
                            <div className={`${isToday ? 'schelule_at' : 'rest_of_schelule_at'}`}>
                                <FiClock className="w-4 h-4" />
                                <span>Schedule at {new Date(item.scheduled_publish_at).toLocaleTimeString("en-US", {hour: "numeric",minute: "2-digit",hour12: true,})}</span>
                            </div>
                        }
                    </div>
                    <div className="queue_body_title">{item?.content_title}</div>
                    <div className='queue_body_desc' dangerouslySetInnerHTML={{ __html: item?.content_story }} />
                    <hr style={{opacity:0.1}}/>
                    <div className='queue_footer d-flex justify-content-between'>
                        <div className='d-flex' style={{ gap: '32px', alignItems: 'center' }}>
                            {item?.scheduled_by && <div><div className='text_type'>SCHEDULED BY</div><div className='text_value'>{item?.scheduled_by?.charAt(0).toUpperCase() + item.scheduled_by.slice(1)}</div></div>}
                            {item?.author && <div><div className='text_type'>AUTHOR</div><div className='text_value'>{item?.author?.charAt(0).toUpperCase() + item.author.slice(1)}</div></div>}
                        </div>
                        <div className='d-flex' style={{ gap: '16px', alignItems: 'center' }}>
                            {findPermission('content_scheduler','can_reschedule_content') && (
                                <div className='reschedule' onClick={() => handleReschedule(item)}>
                                    <GoCalendar />
                                    <span>{item?.scheduled_publish_at ? 'Reschedule' : 'Schedule'}</span>
                                </div>
                            )}
                            <MoreTooltip
                                onEdit={() => (item?.draft_edit_url && (window!=undefined)) && window?.open(item.draft_edit_url,'_blank')}
                                onPublish={() => handlePublishNow(item)}
                                onCancel={() => handleCancleSchedule(item)}
                            />
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );

    // formating date for adding title as toaday or tomorrow
    const formatDateHeader = (dateStr) => {
        const today = new Date();
        const targetDate = new Date(dateStr);

        if (targetDate.toDateString() === today.toDateString()) {
            return `Today: ${dateStr}`;
        }

        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);
        if (targetDate.toDateString() === tomorrow.toDateString()) {
            return `Tomorrow: ${dateStr}`;
        }

        return dateStr;
    };

    return (
        <div className="scheduler_custom_container mb-5">
            {/* to show success message on top */}
            {(customTime?.value && putScheduleDraftsData || publishNowData) &&(
                <ShowToastMsg data={successMsg} succeeded={true}/>
            )}

            {/* to show Publish Now related error message on top */}
            {punlishNowError &&
                <ShowToastMsg data={punlishNowError?.message} succeeded={false}/>
            }

            {/* to show loader if API is in loading state */}
            {(queueDrafsLoading && queueDraftsData?.results?.length === 0 && props.queueCurrentPage==1) &&(
                <div className="flex justify-center items-center py-8">
                    <Loading className="draft_loader"/>
                </div>
            )}

            {/* showing no data found if there is no data available else showing data as cards */}
            {(queueDraftsData?.results?.length === 0) && (
                <div className="my-5 ">
                    <NoDataFound/>
                </div>
            ) }

            {(Object.keys(groupedData).length > 0)&&  (
                Object.keys(groupedData)
                    .sort((a, b) => new Date(a) - new Date(b))
                    .map((date, index) => (
                        <div key={index} className="mb-5">
                            <div className="d-flex align-items-center mb-2">
                                <h2 className="queue_bloc_date">{formatDateHeader(date)}</h2>
                            </div>

                            <div>
                                {groupedData[date].map((item, ind) => (
                                    <ContentCard key={item.id} item={item} parentIndex={index} isToday={String(formatDateHeader(date))?.includes('Today')}/>
                                ))}
                            </div>
                        </div>
                    )
                )
            )}

            {/* open popup for scheduling draft=> Set Schedule Form */}
            {showSchedulePopup && (
                <SetSchedulePopup 
                    open={showSchedulePopup} 
                    setOpen={setSchedulePopup}
                    customDate={customDate}
                    setCustomDate={setCustomDate}
                    customTime={customTime}
                    setCustomTime={setCustomTime}
                 />
            )}

            {/* showing loader for paginated data */}
            {queueDrafsLoading && props.queueCurrentPage> (
                <div className="text-center py-4">
                    <Loading className="" />
                </div>
            )}


            {/* Intersection Observer Target */}
            <div ref={observerRef} style={{ height: '1px' }}></div>
        </div>
    );
};

export default ScheduledContentDashboard;